import * as React from 'react';
import moment from 'moment';

interface CalendarNavigationArgs {
  calendarRef: React.RefObject<HTMLDivElement>;
  handleMonthStep: (e, step) => void;
  handleYearStep: (e, step) => void;
}

const step = {
  ArrowLeft: -1,
  ArrowRight: 1,
  ArrowUp: -7,
  ArrowDown: 7,
};

export const useCalendarKeyboardNavigation = ({
  calendarRef,
  handleMonthStep,
  handleYearStep,
}: CalendarNavigationArgs) => {
  React.useEffect(() => {
    const calendarNode = calendarRef.current;
    if (!calendarNode) {
      return;
    }

    const keyboardHandler = (event: KeyboardEvent) => {
      if (!(event.key in step)) {
        return;
      }

      // if the event target is month / year selector, return
      const currentDate = (event.target as HTMLElement).getAttribute('data-date');
      if (!currentDate) {
        return;
      }

      event.preventDefault();

      // if the event target is a calendar date button
      // use `step` to calculate the offset
      // if post-offset date is in the previous or next month, then change month

      const momentCurrentDate = moment(currentDate);
      const nextDate = momentCurrentDate.add(step[event.key], 'days').format('YYYY-MM-DD');
      const nextDateButton = calendarNode.querySelector<HTMLButtonElement>(`[data-date="${nextDate}"]`);

      if (!nextDateButton) {
        handleMonthStep(event, step[event.key] > 0 ? 1 : -1);
        calendarNode.querySelector<HTMLButtonElement>(`[data-date="${nextDate}"]`)?.focus();
      } else {
        nextDateButton.focus();
      }
    };

    calendarNode.addEventListener('keydown', keyboardHandler);

    return () => {
      calendarNode.removeEventListener('keydown', keyboardHandler);
    };
  }, [calendarRef, handleMonthStep, handleYearStep]);
};
